import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, generatePath } from 'react-router-dom';
import { Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Title } from 'src/core/components';
import { routes } from 'src/constants';
import { clearNotifications as clearNotificationsAction } from 'src/core/redux/actions';

import Plate from './Plate';
import messages from './messages';
import './Plates.style.scss';

const Plates = ({ plates, removePlate, clearNotifications }) => {
  const history = useHistory();

  const navigateToPlatePage = async (plateName) => {
    const newPath = generatePath(routes.EDIT_PLATE_PAGE, { plateName });

    await clearNotifications();

    history.push(newPath);
  };

  return (
    <>
      <Title size="4" font="bold" message={messages.plates} />
      <Spacer bottom={14} />
      {plates?.map((plate) => (
        <Plate
          key={plate?.plateName}
          plate={plate}
          removePlate={() => removePlate(plate)}
          editPlate={() => navigateToPlatePage(plate?.plateName)}
        />
      ))}
    </>
  );
};

Plates.propTypes = {
  plates: PropTypes.array,
  removePlate: PropTypes.func.isRequired,
  clearNotifications: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  clearNotifications: clearNotificationsAction,
};

export default connect(null, mapDispatchToProps)(Plates);
